import { AGENT_PROFILE, BUYER_PROFILE } from "../../gql/MessagesQueries";

import MoreIcon from "@/assets/images/icons/more_vertical.svg?inline";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";
import BackIcon from "@/assets/images/icons/back.svg?inline";
import AvatarIcon from "@/assets/images/icons/chat_avatar.svg?inline";

export default {
  name: "user_info",

  data() {
    return {
      opponent: {},

      agentProfile: {},
      buyerProfile: {},
      conciergeProfile: {},

      skipAgentInfoQuery: true,
      skipBuyerInfoQuery: true,

      isLoadingUserInfo: false
    };
  },

  props: {
    userData: {
      type: Object,
      default: {}
    },
    channelData: {
      type: Array,
      default: []
    },
    isInitChannel: Boolean
  },

  apollo: {
    agentProfile: {
      query: AGENT_PROFILE,
      variables() {
        return {
          id: this.opponent.id
        };
      },

      skip() {
        return this.skipAgentInfoQuery;
      },

      result() {
        this.skipAgentInfoQuery = true;
        this.isLoadingUserInfo = false;
      }
    },

    buyerProfile: {
      query: BUYER_PROFILE,
      variables() {
        return {
          id: this.opponent.id
        };
      },

      skip() {
        return this.skipBuyerInfoQuery;
      },

      result() {
        this.skipBuyerInfoQuery = true;
        this.isLoadingUserInfo = false;
      }
    }
  },

  mounted: function() {
    if (this.channelData.length > 0) {
      this.getChatOpponent(this.channelData);
    }
  },

  computed: {
    opponentFullInfo() {
      if (this.opponent) {
        switch (this.opponent.role) {
          case "agent":
            return this.agentProfile.userInfo;

          case "buyer":
            return this.buyerProfile.userInfo;

          case "concierge":
            break;

          default:
            this.skipBuyerInfoQuery = false;
            break;
        }
      }
    },

    fullName() {
      if (this.opponentFullInfo.id) {
        return `${this.opponentFullInfo.firstName} ${this.opponentFullInfo.lastName}`;
      }
    },

    isMobile() {
      return this.$mq === "sm" || this.$mq === "xs";
    }
  },

  methods: {
    getChatOpponent(data) {
      if (data.length && this.userData.id) {
        this.opponent = data.find(u => {
          return u.id != this.userData.id;
        });

        switch (this.opponent.role) {
          case "agent":
            this.skipAgentInfoQuery = false;
            break;

          case "buyer":
            this.skipBuyerInfoQuery = false;
            break;

          case "concierge":
            this.isLoadingUserInfo = false;
            this.conciergeProfile = this.opponent;

            break;

          default:
            this.skipBuyerInfoQuery = false;
            break;
        }
      }
    },

    showRefuseModal() {
      this.$emit("showRefuseModal");
    },

    showReportModal() {
      this.$emit("showReportModal");
    },

    backToChannelsList() {
      this.$emit("backToChannelsList");
    }
  },

  watch: {
    channelData: function(newData) {
      this.isLoadingUserInfo = true;

      if (newData.length > 1) {
        this.getChatOpponent(newData);
      }
    }
  },

  components: { MoreIcon, LoadingIcon, BackIcon, AvatarIcon }
};
